import { Type } from '@angular/core';

import { RequiredValidatorEditorComponent } from '../validators/editors/required-validator-editor/required-validator-editor.component';
import { UniqueValidatorEditorComponent } from '../validators/editors/unique-validator-editor/unique-validator-editor.component';
import { StringLengthValidatorEditorComponent } from '../validators/editors/string-length-validator-editor/string-length-validator-editor.component';
import { RegexValidatorEditorComponent } from '../validators/editors/regex-validator-editor/regex-validator-editor.component';
import { DigitalRangeValidatorEditorComponent } from '../validators/editors/digital-range-validator-editor/digital-range-validator-editor.component';
import { DigitalTypeValidatorEditorComponent } from '../validators/editors/digital-type-validator-editor/digital-type-validator-editor.component';
// tslint:disable-next-line: max-line-length
import { FileUploadFileTypeValidatorEditorComponent } from '../validators/editors/file-upload-file-type-validator-editor/file-upload-file-type-validator-editor.component';
// tslint:disable-next-line: max-line-length
import { FileUploadFileSizeValidatorEditorComponent } from '../validators/editors/file-upload-file-size-validator-editor/file-upload-file-size-validator-editor.component';
import { UnionCheckValidatorEditorComponent } from '../validators/editors/union-check-validator-editor/union-check-validator-editor.component';

import { ControlValidatorSpecification } from '../types/specification.types';
import { ControlValidatorType, AbstractValidatorEditor } from '../types/validator.types';

export function getRequiredValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.Required, RequiredValidatorEditorComponent);
}

export function getUniqueValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.Unique, UniqueValidatorEditorComponent);
}

export function getStringLengthValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.StringLength, StringLengthValidatorEditorComponent);
}

export function getRegularExpressionValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.RegularExpression, RegexValidatorEditorComponent);
}

export function getDigitalRangeValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.DigitalRange, DigitalRangeValidatorEditorComponent);
}

export function getDigitalTypeValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.DigitalType, DigitalTypeValidatorEditorComponent);
}

export function getFileTypeOfUploadValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.FileTypeOfUpload, FileUploadFileTypeValidatorEditorComponent);
}

export function getFileSizeOfUploadValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.FileSizeOfUpload, FileUploadFileSizeValidatorEditorComponent);
}

export function getUnionCheckValidatorSpecification(): ControlValidatorSpecification {
  return buildValidatorSpecification(ControlValidatorType.UnionCheck, UnionCheckValidatorEditorComponent);
}

/**
 * @description æå»ºéªè¯å¨è§æ ¼
 *
 * @export
 * @param name åç§°
 * @param component å¯¹åºéªè¯å¨ç¼è¾å¨ç±»
 * @param [caption] æ é¢
 * @param [groupName] åç»åç§°
 * @param [settings] è®¾ç½®
 * @returns
 */
export function buildValidatorSpecification(
  name: string,
  component: Type<AbstractValidatorEditor<any>>,
  caption?: string,
  groupName?: string,
  settings?: any
) {
  const validatorsSpecification: ControlValidatorSpecification = {
    name: name,
    groupName: groupName,
    caption: caption,
    component: component,
    settings: settings
  };
  return validatorsSpecification;
}
